var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activation-popup"},[_c('br'),_c('h2',[_vm._v(_vm._s(this.$i18n.t('_informations')))]),_c('br'),_c('p',{domProps:{"innerHTML":_vm._s(this.$i18n.t('_your_service_activation_info', {link: _vm.linkToProfile}))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }